export const config = {
  name: {
    required: true,
    value: '',
    hasDynamicRule: true
  },
  workflowId: {
    required: true,
    value: null
  },
  targetLanguage: {
    required: true,
    value: []
  },
  targetFormat: {
    value: null
  },
  dueDate: {
    required: true,
    value: null,
    rules: [
      (value: Date) => ({
        valid: !!value,
        'data-commonnamespace': true,
        'data-error': 'validationErrorMessages.fieldRequired'
      }),
      (value: Date) => ({
        valid: value > new Date(),
        'data-error': 'v_batchDueDateInThePast'
      })
    ]
  }
};
